/* Code: the coding agent's IDE (AGENT-10), code cells and data analysis (AGENT-03) and the sandbox
   viewer (AGENT-02). API: api/src/modules/sandbox/README.md. */
import { lazy } from 'react';
import { CodeXml } from 'lucide-react';
import { defineFeature } from '../../app/feature';

export default defineFeature({
  id: 'code',
  title: 'Code',
  icon: CodeXml,
  group: 'Apps',
  route: '/code',
  order: 70,
  screen: lazy(() => import('./Screen.tsx')),
  commands: [
    { id: 'new-task', title: 'New coding task', to: '/code?new=1', keywords: ['code', 'repo', 'pull request', 'agent', 'github'] },
    { id: 'run', title: 'Run code in a sandbox', to: '/code/run', keywords: ['python', 'javascript', 'notebook', 'execute'] },
    { id: 'data', title: 'Analyze a spreadsheet', to: '/code/data', keywords: ['csv', 'xlsx', 'chart', 'profile', 'data'] },
  ],
  capabilities: ['AGENT-10', 'AGENT-03', 'AGENT-02'],
});
